export const COINSCRAP_ROUNDS = 'COINSCRAP_ROUNDS';
export const PERIODIC_SAVING = 'PERIODIC_SAVING';
export const AHORRO_HOT = 'AHORRO_HOT';
export const EARNINGS_SAVING = 'EARNINGS_SAVING';
export const CAFEINE = 'CAFEINE';
export const NICOTINE = 'NICOTINE';
export const TEAM = 'TEAM';
